<template>
  <div class="page--home">
    <v-container fluid>
      <v-row class="mt-10">
        <v-col class="text-center">
          <h1
            class="text-h3 grey--text text--darken-3 font-weight-light text-uppercase"
          >
            Olá, {{ user.fullName }}
          </h1>
          <p class="mt-4 grey--text text--darken-3 font-weight-light">
            Escolha um das opções de menu e acesse
            <br />
            as funcionalidades do {{ $configurations.app.alias }}
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import pageLoadingMixin from "mixins/page-loading.mixin";
import configurations from 'commons/configurations';
import { AUTH_NAMESPACE, USER, ABILITIES, MENU } from 'store/modules/auth';
export default {
  name: "Home",
  mixins: [pageLoadingMixin],
  components: {},
  data: () => ({
    app: {
      name: configurations.app.name,
      alias: configurations.app.alias
    }
  }),
  computed: {
    user() {
      return {
        ...this.$store.getters[`${AUTH_NAMESPACE}/${USER}`],
        permissions: this.$store.getters[`${AUTH_NAMESPACE}/${ABILITIES}`],
        menu: this.$store.getters[`${AUTH_NAMESPACE}/${MENU}`]
      }
    },
    permissoes() {
      return this.$store.getters[`${AUTH_NAMESPACE}/${ABILITIES}`];
    },
  },
  methods: {
    verificacaoPermissaoTermo() {
      const usuarioSad = this.user?.sad;
      const primeiroAcesso = this.user?.firstAccess;
      const redirecionarParaCadastro = usuarioSad && primeiroAcesso;
      const rotaDestino = redirecionarParaCadastro
        ? '/cadastro-pedagogico/profissional'
        : '/app';
      this.$router.push(rotaDestino).catch(() => {});
    }
  },
  mounted() {
    this.verificacaoPermissaoTermo();
    const usuarioSad = this.user?.sad;
    const parecerRecusado = this.user?.parecerRecusado;
    if (usuarioSad && parecerRecusado) {
      return this.$router.push({ path: '/cadastro-pedagogico/profissional' }).catch(() => {});
    }
  }
};
</script>
